/**
 * Created by Carsten Bühler
 * User: CBuehler on 12.02.2016
 * Copyright: xdot GmbH 2015
 */
'use strict';

//Includes
import React from 'external/react';
import {
    amdRequire,
    FormActions,
    PortletComponent,
    UidUtil,
    wrapWithCommonFormContainer
} from 'plugin/liferay-widgets-react-web';

import WebCamWidgetConfigForm from './WebCamWidgetConfigForm';
import ImageDisplay from '../components/ImageDisplay';
import { JournalEntryAddForm } from '../components/JournalEntryAddForm';
import  JournalAddEntryButton  from '../components/JournalAddEntryButton';
import { JournalTypeNames } from '../constants/Constants';

const WebCamWidgetConfigFormHoc = wrapWithCommonFormContainer(WebCamWidgetConfigForm);
const JournalEntryAddFormHoc = wrapWithCommonFormContainer(JournalEntryAddForm);

class WebCamWidget extends PortletComponent {

    constructor(props){
        super(props);
        this.DATA = {
            FORM_ADD_JOURNAL_ENTRY: UidUtil.generateId('FormAddJournalEntry')
        };

        this.onJournalEntryAdd = this.onJournalEntryAdd.bind(this);
        this.onJournalEntryAddFormSubmit = this.onJournalEntryAddFormSubmit.bind(this);
    }

    renderConfigForm(props){
        return (<WebCamWidgetConfigFormHoc {...props} />);
    }

    componentWillUnmount(){
        if (this.timer) {
            clearInterval(this.timer);
        }
    }

    configWillChange(prevConfig, nextConfig){
        this.isRefreshing = false;
        console.log('configWillChange', prevConfig, ' ==> ', nextConfig);
        if (this.timer) {
            clearInterval(this.timer);
        }
        if (nextConfig.refreshInterval > 0) {
            this.timer = setInterval(this.refreshWidget.bind(this, nextConfig), nextConfig.refreshInterval * 1000);
            this.refreshWidget(nextConfig);
        }
    }

    refreshWidget(config){
        this.isRefreshing = true;
        const { imageUrl, portletSetupTitle_de_DE } = config;
        const { time } = this.state;
        let url = imageUrl;

        if (imageUrl.indexOf('?') < 0) {
            url += '?cct=' + time;
        } else if (imageUrl.indexOf('cct') < 0) {
            url += '&cct=' + time;
        } else {
            url = imageUrl.split('cct')[0] + 'cct=' + time;
        }

        if (config.username && config.username.length > 0 && config.password && config.password.length > 0) {

            this.getImageBlob(url, config).then(resp => {
                this.setState({ url: window.URL.createObjectURL(resp) });
            }).catch(e => {
                console.error(e);
                this.setState({ url });
            });

            this.setState({
                time: new Date().getTime(),
                imgData: new Date().getTime(),
                portletTitle: portletSetupTitle_de_DE,
                url: undefined
            });
        } else {
            this.setState({
                time: new Date().getTime(),
                imgData: new Date().getTime(),
                portletTitle: portletSetupTitle_de_DE,
                url
            });
        }
    }

    imageToBlob(){
        return new Promise((resolve, reject) => {
            const img = new Image;
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            img.onload = () => {
                canvas.width = img.naturalWidth;
                canvas.height = img.naturalHeight;
                ctx.drawImage(img, 0, 0);
                canvas.toBlob(function (blob){
                    resolve(blob);
                }, 'image/jpeg', 0.85);
            };
            img.onerror = reject;
            img.crossOrigin = 'Anonymous';
            img.src = this.state.url;
        });
    }

    getImageBlob(url, config){
        return new Promise(function (resolve, reject){
            try {
                const xhr = new XMLHttpRequest();
                xhr.responseType = 'blob';
                if (config.username && config.username.length > 0 && config.password && config.password.length > 0) {
                    xhr.withCredentials = true;
                }
                xhr.open('GET', url, true, config.username, config.password);
                xhr.onload = function (oEvent){
                    if (xhr.status === 200) {resolve(xhr.response);} else {reject('Loading error:' + xhr.statusText);}
                };
                xhr.onerror = function (){
                    reject(xhr.response);
                };
                xhr.send();
            } catch (err) {reject(err.message);}
        });
    }

    onJournalEntryAdd(){
        const { portletTitle } = this.state;
        FormActions.startEditFormItem(this.DATA.FORM_ADD_JOURNAL_ENTRY, {
            title: ''
        });
    }

    onJournalEntryAddFormSubmit(formData){
      //  this.imageToBlob().then(resp => {
            const entryData = {
                url: this.state.url,
                type: JournalTypeNames.Webcam,
                message: { ...formData, url: this.state.url, },
                //attachments: { image: resp },
                attachments: { image__URL__UPLOAD: this.state.url },
                groupId: Liferay.ThemeDisplay.getScopeGroupId()
            };
            amdRequire(['journal-portlet/js/journal-portlet'], (J) => {
                J.JournalActions.addEntry(entryData, this.DATA.FORM_ADD_JOURNAL_ENTRY, true);

            });
       // }).catch(e => console.error(e));
    }

    isConfigurationNeeded(config){
        return (!config || (config && !config.imageUrl));
    }

    renderPortlet(config){
        const { url } = this.state;

        return (
            <React.Fragment>
                <JournalEntryAddFormHoc
                    formId={this.DATA.FORM_ADD_JOURNAL_ENTRY}
                    showReset={true}
                    onFormSubmit={this.onJournalEntryAddFormSubmit}
                    editTitle={true}
                    modalProps={{
                        aboveLiferayDialog: true,
                        size: 'md'
                    }}
                />

                <JournalAddEntryButton onClick={this.onJournalEntryAdd}/>
                {
                    url &&
                    <ImageDisplay
                        thumbnailUrl={url}
                        previewUrl={url}
                    />
                }
                {!url && <div>Bild wird geladen...</div>}
            </React.Fragment>
        );
    }
}

WebCamWidget.propTypes = {};

export default WebCamWidget;



// WEBPACK FOOTER //
// ./js/widgets/WebCamWidget.jsx